export class OrderAmountError extends Error {
  constructor(message) {
    super(message);
    this.name = 'OrderAmountError';
  }
}

function consistentMinorAmount(fieldName, ...values) {
  const presentValues = values.filter(candidate => candidate != null);
  if (presentValues.length === 0) return null;
  for (const value of presentValues) {
    if (!Number.isSafeInteger(value) || value < 0) {
      throw new OrderAmountError('Order money must use non-negative integer minor units.');
    }
  }
  if (presentValues.some(value => value !== presentValues[0])) {
    throw new OrderAmountError(`Persisted ${fieldName} aliases are inconsistent.`);
  }
  return presentValues[0];
}

/** Normalize legacy and v2 persistence names without converting through floats. */
export function normalizeOrderAmounts(orderData = {}) {
  const subtotalAmount = consistentMinorAmount(
    'subtotal',
    orderData.subtotalAmount,
    orderData.subtotalMinor,
    orderData.subtotal,
  );
  const taxAmount = consistentMinorAmount(
    'tax',
    orderData.taxAmount,
    orderData.taxMinor,
    orderData.tax,
  );
  let totalAmount = consistentMinorAmount(
    'total',
    orderData.totalAmount,
    orderData.totalMinor,
    orderData.total,
  );

  if (subtotalAmount != null && taxAmount != null) {
    const calculatedTotal = subtotalAmount + taxAmount;
    if (!Number.isSafeInteger(calculatedTotal)) {
      throw new OrderAmountError('Order total exceeds the safe integer range.');
    }
    if (totalAmount != null && totalAmount !== calculatedTotal) {
      throw new OrderAmountError('Persisted order totals are internally inconsistent.');
    }
    totalAmount = totalAmount ?? calculatedTotal;
  }

  return { subtotalAmount, taxAmount, totalAmount };
}
